import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const appointmentCalenderVdsPro = Loadable(() => import('../../containers/web/appointmentCalenderVdsPro'));
export default MapTo('vcg/components/soe-home/react/appointmentCalenderVdsPro')(appointmentCalenderVdsPro);
